/**
 * Animações de entrada leves (substituem framer-motion).
 * Elementos com a classe `reveal` ficam ocultos via CSS (só com JS ativo)
 * e ganham `is-in` quando entram na tela. Um único IntersectionObserver
 * atende a página inteira, inclusive elementos montados depois.
 */
let started = false;

export function initReveal() {
  if (started || typeof window === "undefined") return;
  started = true;

  const reveal = (el: Element) => el.classList.add("is-in");

  if (typeof IntersectionObserver === "undefined") {
    document.querySelectorAll(".reveal").forEach(reveal);
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          reveal(e.target);
          io.unobserve(e.target);
        }
      }
    },
    { rootMargin: "0px 0px -60px 0px", threshold: 0.05 },
  );

  const scan = (root: ParentNode) => {
    root.querySelectorAll(".reveal:not(.is-in)").forEach((el) => io.observe(el));
  };
  scan(document);

  new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes.forEach((n) => {
        if (n instanceof Element) {
          if (n.matches(".reveal:not(.is-in)")) io.observe(n);
          scan(n);
        }
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
}
